import { render, staticRenderFns } from "./table-chips.vue?vue&type=template&id=c0b66e28&scoped=true"
import script from "./table-chips.vue?vue&type=script&lang=js"
export * from "./table-chips.vue?vue&type=script&lang=js"
import style0 from "./table-chips.vue?vue&type=style&index=0&id=c0b66e28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b66e28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0b66e28')) {
      api.createRecord('c0b66e28', component.options)
    } else {
      api.reload('c0b66e28', component.options)
    }
    module.hot.accept("./table-chips.vue?vue&type=template&id=c0b66e28&scoped=true", function () {
      api.rerender('c0b66e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/table-chips.vue"
export default component.exports